import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { onFeaturesReady, isSSR } from 'oasis-os-react';
import { setupIonicReact } from '@ionic/react';
import * as serviceWorker from '../serviceWorkerRegistration';
import { isPlatform } from '@ionic/core';
import * as ReactDOMClient from 'react-dom/client';

import App from './FeatureApp';

setupIonicReact();

const rootElement = document.getElementById('root')!;
const root = ReactDOMClient.createRoot(rootElement);

if (isSSR() || rootElement?.childElementCount === 0) {
  root.render(<App />);
} else {
  onFeaturesReady(() => {
    hydrateRoot(rootElement, <App />);
  });
}
if (!isPlatform('hybrid')) serviceWorker.register(process.env.PUBLIC_PATH ?? '/');